module.exports = __webpack_public_path__ + "static/media/sg.ae32bb35.svg";